export default function makeOnPaste(store) {
  return {
    onPaste: function onPaste(event, editor, next) {
      if (!editor.isSelectionInTable()) {
        return next();
      }

      event.preventDefault();
      event.stopPropagation();
      var fragment = editor.query('getFragmentFromEvent', event);
      editor.mergeCurrentTableWithFragment(fragment);
      return editor;
    },
    onDocumentPaste: function onDocumentPaste(event, editor) {
      var tableId = store.getItem('lastFocusedTableId');
      if (!tableId) return; // No table selected

      event.preventDefault();
      event.stopPropagation();
      var firstCell = editor.getSelectedTableCells().first();
      if (!firstCell) return;
      editor.moveTo(firstCell.getFirstText().key);
      var fragment = editor.query('getFragmentFromEvent', event);
      editor.mergeCurrentTableWithFragment(fragment).focus();
    }
  };
}